module.exports = __webpack_public_path__ + "img/pinestone-logo-fr.9f992c6e.png";